<template>
  <generic-modal :title="$t('event')" ref="generic_modal">
    <div class="tabs is-toggle is-fullwidth" ref="tabs">
      <ul>
        <li
          class="is-active"
          data-tab="general"
          @click="change_active_tab($event, this)"
        >
          <a>
            <i class="info icon" aria-hidden="true"></i>
            <span>{{ $t("general") }}</span>
          </a>
        </li>
        <li data-tab="revision" @click="change_active_tab($event, this)">
          <a>
            <i class="stethoscope icon" aria-hidden="true"></i>
            <span>{{ $t("revision") }}</span>
          </a>
        </li>
        <li data-tab="maintenance" @click="change_active_tab($event, this)">
          <a>
            <i class="wrench icon" aria-hidden="true"></i>
            <span>{{ $t("maintenance") }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="is-fluid" ref="contents">
      <div class="" data-tab="general">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("date") }}</label>
              <div class="control">
                <input
                  type="datetime-local"
                  class="input"
                  v-model="meta.date"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <!-- <div class="field">
              <input
                class="is-checkradio"
                type="checkbox"
                id="chk_is_recurrent"
                name="chk_is_recurrent"
                v-model="meta.is_recurrent"
              />
              <label for="chk_is_recurrent">{{ $t("is recurrent") }}</label>
            </div> -->
            <div class="field">
              <label class="label">{{ $t("customer") }}</label>
              <div class="control">
                <input class="input" type="text" v-model="meta.customer" />
              </div>
            </div>
          </div>
        </div>
        <div class="field">
          <label class="label">{{ $t("service reason") }}</label>
          <div class="control">
            <textarea
              class="textarea"
              rows="2"
              v-model="meta.service_reason"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="is-hidden" data-tab="revision">
        <div class="field">
          <label class="label">{{ $t("diagnostic") }}</label>
          <div class="control">
            <textarea
              class="textarea"
              rows="2"
              v-model="meta.diagnostic"
            ></textarea>
          </div>
        </div>
        <div class="field">
          <div class="control">
            <generic-uploader
              ref="revision_uploader"
              :idle_label="$t('drop photos here')"
              endpoint_url="/eserman/event/photo"
              @error="error_uploading"
              @success="success_uploading_revision"
              :allow_multiple="true"
            />
          </div>
        </div>

        <div class="grid is-col-min-7" v-if="meta.settings">
          <div
            class="cell"
            v-for="(photo, pidx) in meta.settings.revision_photos"
            :key="pidx"
          >
            <div class="card">
              <div class="card-image">
                <figure class="image is-128x128 m-auto py-3">
                  <v-lazy-image
                    :src="`${api_host}/drive/static/${photo.final_name}`"
                  />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-content">
                    <!-- <p class="subtitle is-7 has-text-centered">
                  {{ photo.file }}
                </p> -->
                    <p class="subtitle is-7 has-text-centered">
                      {{ photo.description }}
                    </p>
                  </div>
                </div>
              </div>
              <footer class="card-footer">
                <div
                  class="button is-secondary card-footer-item"
                  @click="remove_revision_photo(pidx)"
                  :data-tooltip="$t('delete')"
                >
                  <span class="icon">
                    <i class="fa fa-trash"></i>
                  </span>
                  <!-- <span>{{ $t("delete") }}</span> -->
                </div>
                <div
                  class="button is-secondary card-footer-item"
                  @click="describe_revision_photo(photo)"
                  :data-tooltip="$t('describe')"
                >
                  <span class="icon">
                    <i class="fa fa-edit"></i>
                  </span>
                </div>
              </footer>
            </div>
          </div>
        </div>
      </div>
      <div class="is-hidden" data-tab="maintenance">
        <div class="field">
          <label class="label">{{ $t("final words") }}</label>
          <div class="control">
            <textarea
              class="textarea"
              rows="2"
              v-model="meta.final_words"
            ></textarea>
          </div>
        </div>
        <div class="field">
          <div class="control">
            <generic-uploader
              ref="maintenance_uploader"
              :idle_label="$t('drop photos here')"
              endpoint_url="/eserman/event/photo"
              @error="error_uploading"
              @success="success_uploading_maintenance"
              :allow_multiple="true"
            />
          </div>
        </div>

        <div class="grid is-col-min-7" v-if="meta.settings">
          <div
            class="cell"
            v-for="(photo, pidx) in meta.settings.maintenance_photos"
            :key="pidx"
          >
            <div class="card">
              <div class="card-image">
                <figure class="image is-128x128 m-auto py-3">
                  <v-lazy-image
                    :src="`${api_host}/drive/static/${photo.final_name}`"
                  />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-content">
                    <!-- <p class="subtitle is-7 has-text-centered">
                  {{ photo.file }}
                </p> -->
                    <p class="subtitle is-7 has-text-centered">
                      {{ photo.description }}
                    </p>
                  </div>
                </div>
              </div>
              <footer class="card-footer">
                <div
                  class="button is-secondary card-footer-item"
                  @click="remove_maintenance_photo(pidx)"
                  :data-tooltip="$t('delete')"
                >
                  <span class="icon">
                    <i class="fa fa-trash"></i>
                  </span>
                  <!-- <span>{{ $t("delete") }}</span> -->
                </div>
                <div
                  class="button is-secondary card-footer-item"
                  @click="describe_maintenance_photo(photo)"
                  :data-tooltip="$t('describe')"
                >
                  <span class="icon">
                    <i class="fa fa-edit"></i>
                  </span>
                </div>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
      <button
        class="button is-danger is-rounded"
        @click="remove"
        v-if="meta && meta.uuid"
      >
        <span class="icon">
          <i class="fa fa-trash"></i>
        </span>
        <span>{{ $t("delete") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  del,
  get,
  post,
  error_alert,
  api_host,
  input_alert,
  generate_error_message_text,
  get_currency_settings,
  confirm_deletion_dialog,
  format_date,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import moment from "moment";
import { v4 } from "uuid";
import VLazyImage from "v-lazy-image";

export default {
  name: "EventModal",
  components: { GenericModal, GenericCalendar, GenericUploader, VLazyImage },
  data() {
    let v = this;
    return {
      api_host,
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.date || !v.meta.customer;
    },
  },
  methods: {
    change_active_tab,
    moment,
    format_date,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(event_info) {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
      v.meta.date = moment(event_info.date).format("YYYY-MM-DDTHH:mm");
    },
    save() {
      let v = this;
      if (!v.meta.uuid) {
        put("/eserman/event", {
          ...v.meta,
        })
          .then((r) => {
            v.$emit("updated", r);
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        post("/eserman/event", {
          ...v.meta,
        })
          .then((r) => {
            v.$emit("updated", r);
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        customer: "",
        date: "",
        is_recurrent: false,
        settings: {},
      };
      v.error = "";
      v.$refs.revision_uploader.clear();
      v.$refs.maintenance_uploader.clear();
      // v.$refs.generic_uploader.clear();
    },
    date_changed(date) {
      let v = this;
      v.meta.date = moment(date).toISOString();
    },
    edit_modal(event_uuid, date) {
      // console.log("edit_modal", event_uuid, date);
      let v = this;
      v.$refs.generic_modal.show_modal();
      // v.event_info = { date: date };
      get("/eserman/event", { uuid: event_uuid })
        .then((event) => {
          v.meta = event;
          if (event.date)
            v.meta.date = moment(event.date).format("YYYY-MM-DDTHH:mm");

          //     if (event.settings && event.settings.coach_photo) {
          //       else v.meta.settings = { coach_photo: event.settings.coach_photo };
          //     }
        })
        .catch((error) => {
          console.error("error", error);
          v.error = generate_error_message_text(error);
        });
    },
    remove() {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete event?"), v, () => {
        del("/eserman/event", { uuid: v.meta.uuid })
          .then(() => {
            v.$emit("updated");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      });
    },
    error_uploading(error) {
      let v = this;
      v.error = generate_error_message_text(error);
    },
    success_uploading(response) {
      let v = this;
      // v.$refs.generic_uploader.clear();
      let rspnse = JSON.parse(response.serverId);
      // let data = {
      //   file_id: rspnse.file.file_id,
      //   final_name: rspnse.final_name,
      // };

      if (v.meta.settings.photos) v.meta.settings.photos.push(rspnse);
      else v.meta.settings.photos = [rspnse];
    },
    success_uploading_revision(response) {
      let v = this;
      let rspnse = JSON.parse(response.serverId);
      if (v.meta.settings.revision_photos)
        v.meta.settings.revision_photos.push(rspnse);
      else v.meta.settings.revision_photos = [rspnse];
    },
    remove_revision_photo(index) {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete photo?"), v, () => {
        v.meta.settings.revision_photos.splice(index, 1);
      });
    },
    describe_revision_photo(photo) {
      let v = this;
      let options = {
        input: "textarea",
        title: v.$t("describe photo"),
        input_value: photo.description,
        placeholder: v.$t("description"),
        confirm_text: v.$t("save"),
        cancel_text: v.$t("cancel"),
      };
      input_alert(options).then((value) => {
        photo.description = value;
      });
    },
    success_uploading_maintenance(response) {
      let v = this;
      let rspnse = JSON.parse(response.serverId);
      if (v.meta.settings.maintenance_photos)
        v.meta.settings.maintenance_photos.push(rspnse);
      else v.meta.settings.maintenance_photos = [rspnse];
    },
    remove_maintenance_photo(index) {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete photo?"), v, () => {
        v.meta.settings.maintenance_photos.splice(index, 1);
      });
    },
    describe_maintenance_photo(photo) {
      let v = this;
      let options = {
        input: "textarea",
        title: v.$t("describe photo"),
        input_value: photo.description,
        placeholder: v.$t("description"),
        confirm_text: v.$t("save"),
        cancel_text: v.$t("cancel"),
      };
      input_alert(options).then((value) => {
        photo.description = value;
      });
    },
  },
  created() {},
  watch: {},
};
</script>
<style></style>
